import React from 'react';
import { IoCloseCircle } from 'react-icons/io5';
import { BsClockHistory } from 'react-icons/bs';
import { AiFillWarning, AiFillInfoCircle } from 'react-icons/ai';
import { TbProgress } from 'react-icons/tb';
import { BiSolidCheckCircle } from 'react-icons/bi';
import CheckIcon from '@rsuite/icons/legacy/Check';

export const notificationStyles: {
  [key: string]: {
    bgColor: string;
    textColor: string;
    icon: React.ReactElement;
  };
} = {
  INFO: {
    bgColor: 'bg-cancelBg',
    textColor: 'text-success',
    icon: <AiFillInfoCircle size={18} />,
  },
  WARNING: {
    bgColor: 'bg-successBg1',
    textColor: 'text-success',
    icon: <AiFillWarning size={18} />,
  },
  SUCCESS: {
    bgColor: 'bg-success',
    textColor: 'text-success',
    icon: <BiSolidCheckCircle size={18} />,
  },
  ERROR: {
    bgColor: 'bg-cancel',
    textColor: 'text-cancel',
    icon: <IoCloseCircle size={18} />,
  },
};
